import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-icon" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "oztix-logo-icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 57.07 55.67",
  role: "presentation"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "fill",
    d: "M444.33,153.52",
    transform: "translate(-392.52 -121.25)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "fill",
    d: "M405.26,162.3c-10.82-10.39-5-35.33,13.45-25.27,6.12,3.2,10.75,7.64,10.8,9.47a8.81,8.81,0,0,1-.35,3,1.13,1.13,0,0,1-1.72.56,26.41,26.41,0,0,1-3.22-3c-.66-.71-1.15-1.18-1.8-1.82-2.78-2.74-8.54-8.46-14.05-5.12-4.23,2.56-4.09,7.7-4,9.89.19,7,10.3,13.82,14.18,15.85,21.37,11,38.59-11.51,27.72-29.29-5.52-9-15.23-15.6-26.8-15.33l0,3.75c5.56,1.46,12.29,5.79,16.5,9.82a17.92,17.92,0,0,1,5.58,12.64c0,11.74-8.7,18-19.8,12.23-5.11-2.67-10.2-6.74-10.44-9.86a10.87,10.87,0,0,1,.07-2.22,1.3,1.3,0,0,1,2-.94,26.62,26.62,0,0,1,4.14,3.53c.63.63,1,1,1.64,1.66,2.45,2.59,7.54,8,12.91,4.72,2.11-1.28,4.59-4.1,4.42-10.28-.2-7.58-12.15-14.21-14.54-15.46-8.52-4.46-16.39-4.17-22.23.83a12.32,12.32,0,0,0-2.17,2.44c-6.87,10.15-7.67,22.37,3.85,33.73,5.11,5,12.66,9,20.3,9.07l.07-4C415.47,171.23,408.13,165.05,405.26,162.3Z",
    transform: "translate(-392.52 -121.25)"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "loading-text",
  role: "status"
}, "Loading...", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}